import React from 'react';
import { withRouter } from 'react-router-dom';
import { Translation } from 'react-i18next';
import me3Logo from '../../ASUPhotos/logos/me3_logo_black_NEW.png';

class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidMount = () => {
    const { history } = this.props;

    history.listen(() => {
      if (this.state.hasError) {
        this.setState({
          hasError: false,
        });
      }
    });
  };

  componentDidCatch() {
    this.setState({
      hasError: true,
    });
  }

  setNoError = () => {
    this.props.history.goBack();
  };

  backgroundColorPrimary = {
    backgroundColor: `${this.props.tenant.primary}`,
  };

  render() {
    if (this.state.hasError) {
      return (
        <Translation>
          {(t) => (
            <div id="error-page">
              {/* <img className="me3-logo-error" alt="me3 Logo" src={me3Logo} /> */}
              <picture>
                <source
                  media="(max-width: 799px)"
                  srcset={me3Logo}
                  width="480"
                  height="400"
                />
                <source
                  media="(min-width: 800px)"
                  srcset={me3Logo}
                  width="800"
                  height="400"
                />
                <img
                  className="me3-logo-error"
                  alt="me3 Logo"
                  src={me3Logo}
                  width="800"
                  height="400"
                />
              </picture>
              <span className="oops">{t('Oops! Something went wrong.')}</span>
              <button
                type="button"
                tabIndex={0}
                className="button--primary"
                style={this.backgroundColorPrimary}
                onClick={() => {
                  this.setNoError();
                }}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) this.setNoError();
                }}
              >
                {t('Back to the App')}
              </button>
            </div>
          )}
        </Translation>
      );
    }

    return React.Children.toArray(this.props.children);
  }
}

export default withRouter(ErrorPage);
